import { Modal, Button } from "react-bootstrap";
import InformacionUsuario from "../modales/InformacionUsuario";
import AvatarCentrado from "./AvatarCentrado";
import React from "react";

// Helpers por defecto (puedes sobrescribirlos vía props)
const defaultFormatDate = (v) => {
    if (!v) return "—";
    try {
        const d = new Date(v);
        return isNaN(d) ? String(v) : d.toLocaleDateString("es-MX");
    } catch {
        return String(v);
    }
};
const defaultHumanStage = (s) => s || "—";
const isPlaceholder = (v) => {
    if (v == null) return true;
    const s = String(v).trim();
    if (s === "") return true;
    const lower = s.toLowerCase();
    if (["null", "undefined", "n/a", "na"].includes(lower)) return false;
    // solo guiones/dashes: - (ASCII), – (en dash), — (em dash)
    if (/^[-u2013\u2014]+$/.test(s)) return true;
    return false;
  };
const fields = [
    {
        key: "nombre_completo",
        label: "Nombre",
        render: (u) =>
            [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                .filter(Boolean)
                .join(" ") || "—",
    },
    { key: "rfc",          label: "RFC",         render: (u) => (u?.rfc || "—").toUpperCase() },
    { key: "cvven",label: "CVVEN",   render: (u) => u?.cvven || u?.cvven || "—" },
    { key: "Fecha", label: "Fecha", render: (u) => (u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—") },
    { key: "usuario_red",  label: "Usuario Red", render: (u) => (u?.usuario_red || "—").toUpperCase() },
    { key: "fgu_toa", label: "Usuario TOA", render: (u) => { const rol = Number(u?.rol_id); if (![9, 13].includes(rol)) return ""; const hasToa = (u?.fgu_toa ?? "").toString().trim() !== ""; return hasToa ? "✅" : "❌";},},
    { key: "fgu_pi", label: "PI", render: (u) => { const rol = Number(u?.rol_id); if (![9, 13].includes(rol)) return ""; return ((u?.fgu_pi ?? "").toString().trim() !== "") ? "✅" : "❌"; },}
];

export default function DetalleBajaModal({
                                             open,                 // bool
                                             onClose,              // () => void
                                             selected,             // objeto con datos de la solicitud
                                             rolId,                // rol del usuario actual (para botón y TOA si así lo manejas)
                                             onAdvance,            // () => void
                                             humanStage = defaultHumanStage,
                                             formatDate = defaultFormatDate,
                                             zIndex = 11000,
                                         }) {
    if (!selected) return null;

    const canAdvance =
        ((rolId === 3 || rolId === 2) && selected.baja_stage === "SolicitudBaja") ||
        (rolId === 1 && selected.baja_stage === "CapturaBaja") ||
        (rolId === 4 && selected.baja_stage === "Ejecutada");

    const etapaNombre = (stage) => {
        switch (stage) {
            case "SolicitudBaja": return "Solicitud de Baja";
            case "CapturaBaja":   return "Capturar Baja";
            case "Ejecutada":     return "Baja ejecutada";
            default:              return "Etapa de la baja";
        }
    };

    const advanceLabel =
        (rolId === 3 || rolId === 2) ? "Aprobar baja" : rolId === 1 ? "Ejecutar baja" : "Marcar visto";

    return (
        <Modal show={open} onHide={onClose} size="lg" centered style={{ zIndex }}>
            <Modal.Header closeButton>
                <Modal.Title>Detalle de baja</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor"/>
                {/* Card 1: Distribuidores */}
                <InformacionUsuario
                    user={selected}
                    title="Distribuidores"
                    cols={2}
                    hideEmpty={false}
                    fields={[
                        { key: "distribuidor_nombre", label: "Distribuidor" },
                        { key: "distribuidor_rs",     label: "Razón Social" },
                    ]}
                />

                {/* Card 2: Información del Usuario */}
                <InformacionUsuario
                    user={selected}
                    title="Información del Usuario"
                    cols={3}
                    fields={fields}
                />

                                        {/* 5) Bodega (SOLO si hay datos) */}
                                    {(
                                      selected?.bodega_distribuidor ||
                                      selected?.bodega_almacen ||
                                      selected?.bodega_nombre ||
                                      selected?.bodega_region ||
                                      selected?.bodega_direccion
                                    ) && (
                                      <InformacionUsuario
                                        user={selected}
                                        title="Bodega"
                                        cols={2}
                                        hideEmpty={true}
                                        fields={[
                                          { key: "bodega_distribuidor", label: "Distribuidor" },
                                          { key: "bodega_almacen",      label: "Almacén" },
                                          { key: "bodega_nombre",       label: "Bodega" },
                                          { key: "bodega_region",       label: "Región" },
                                          { key: "bodega_direccion",    label: "Dirección" },
                                        ]}
                                      />
                                    )}

                {/* Card 3: Etapa de la baja */}
                <InformacionUsuario
                    user={selected}
                    title="Motivo de baja"
                    cols={2}
                    hideEmpty={false}
                    headerStyle={{ backgroundColor: '#dc3545', color: '#fff' }}
                    fields={[
                        { key: "baja_stage",  label: "Etapa",       render: (u) => etapaNombre(u?.baja_stage) },
                        { key: "supervisor",  label: "Responsable", render: (u) => u?.supervisor || "—" },
                        { key: "razon_baja", label: "Razón de la baja", render: (s) => s?.razon_baja || "—" },
                    ]}
                />
            </Modal.Body>

            <Modal.Footer>
                {canAdvance && (
                    <Button variant="danger" onClick={onAdvance}>
                        {advanceLabel}
                    </Button>
                )}
                <Button variant="secondary" onClick={onClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
